import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/table/table-header.component.js'

const tagName = 'dap-ds-table-header'

/**
 * Table header cell component.
 * @element dap-ds-table-header
 * @title - Table header
 * @group table
 *
 * @slot - The default slot.
 *
 * @csspart base - The main header cell container.
 *
 * @cssproperty --dds-table-header-padding-block - Padding for the top and bottom of the header cell.
 * @cssproperty --dds-table-header-padding-inline-start - Padding for the start (left in LTR) of the header cell.
 * @cssproperty --dds-table-header-padding-inline-end - Padding for the end (right in LTR) of the header cell.
 * @cssproperty --dds-table-header-border-width - Width of the header cell's bottom border.
 * @cssproperty --dds-table-header-border-color - Color of the header cell's bottom border.
 * @cssproperty --dds-table-header-text-color - Text color of the header cell.
 * @cssproperty --dds-table-header-font-weight - Font weight of the header cell text.
 * @cssproperty --dds-table-header-line-height - Line height of the header cell text.
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'DapDSTableHeader',
})

export default reactWrapper
